import BaseEvaluator from './BaseEvaluator';

export default class PasswordEvaluator extends BaseEvaluator {
  constructor(fieldName, friendlyFieldName, model, mutator = null) {
    super(fieldName, friendlyFieldName, model, mutator);
    this.evaluatorName = 'password';
  }

  validate() {
    if (this.value === null || this.value === '') {
      // Allow blank
      this.isValid = true;
    } else {
      this.isValid = this.isStrongEnough();
    }
    return this.isValid;
  }

  isStrongEnough() {
    if (this.value !== undefined && this.value !== null) {
      if (this.value.length < 8) {
        return false;
      }
      const hasUpper = PasswordEvaluator.intersect(this.value, 'ABCDEFGHIJKLMNOPQRSTUVWXYZ').length > 0;
      const hasLower = PasswordEvaluator.intersect(this.value, 'abcdefghijklmnopqrstuvwxyz').length > 0;
      const hasDigit = PasswordEvaluator.intersect(this.value, '0123456789').length > 0;
      const hasSymbol = PasswordEvaluator.intersect(this.value, '!@#$%^&*').length > 0;

      let categoryCount = 0;
      if (hasUpper) {
        categoryCount += 1;
      }
      if (hasLower) {
        categoryCount += 1;
      }
      if (hasDigit) {
        categoryCount += 1;
      }
      if (hasSymbol) {
        categoryCount += 1;
      }
      return categoryCount >= 4;
    }
    return true;
  }

  static intersect(a, b) {
    const setB = new Set(b);
    return [...new Set(a)].filter((x) => setB.has(x));
  }
}
